export const extent = <T>(ds: T[], val: (d: T, i: number, ds: T[]) => number): [number, number] =>
  ds.reduce(
    ([min, max], d, i, ds) => {
      const v = val(d, i, ds);
      if (v < min && v > max) return [v, v];
      else if (v < min) return [v, max];
      else if (v > max) return [min, v];
      return [min, max];
    },
    [0, 0],
  );

export const combineExtents = (extents: [number, number][]): [number, number] => {
  return extents.reduce(
    ([min, max], [curMin, curMax]) => [Math.min(min, curMin), Math.max(max, curMax)],
    [0, 0],
  );
};
